<div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
  <div class="swal2-header">
    
    <div class="swal2-icon swal2-success swal2-icon-show" style="display: flex;">
      <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
      <span class="swal2-success-line-tip"></span>
      <span class="swal2-success-line-long"></span>
      <div class="swal2-success-ring"></div>
      <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
      <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
    </div>

    <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@PasswortChangeSuccess">Ihr Passwort wurde geändert!</h2>
  </div>
  <div class="swal2-content swal2-html-container" i18n="@@PasswortChangeSuccessText">
    Ihr neues Passwort ist ab sofort gültig. Mit dem Klick auf "Ok" werden Sie automatisch abgemeldet und müssen sich mit ihrem neuen Passwort anmelden.
  </div>

  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
      <button type="submit" id="ok" class="swal2-confirm swal2-styled" [disabled]="!formService.form.valid" aria-label="" style="display: inline-block; background-color: green; border-block-color: green;" i18n="@@OkButton">Ok</button>      
    </form>    
  </div>
</div>
